import React, { useContext, useState, useEffect } from 'react';
import SvgIcon from '../../../Components/Common/Component/SvgIcon';
import CustomizerContext from '../../../_helper/Customizer';
import { Tooltip } from 'reactstrap'; // Import Tooltip from reactstrap
import { useTranslation } from 'react-i18next';

const MoonLight = () => {
	const { addMixBackgroundLayout } = useContext(CustomizerContext);
	const [moonlight, setMoonlight] = useState(false);
	const { t } = useTranslation();
	// Set the initial state based on local storage
	useEffect(() => {
		const savedTheme = localStorage.getItem('mix_background_layout');
		if (savedTheme === 'dark-sidebar') {
			setMoonlight(false);
		} else if (savedTheme === 'dark-only') {
			setMoonlight(true);
		}
	}, []);

	const MoonlightToggle = (light) => {
		if (light) {
			addMixBackgroundLayout('dark-sidebar');
			document.body.className = 'dark-sidebar';
			localStorage.setItem('mix_background_layout', 'dark-sidebar');
			setMoonlight(false);
		} else {
			addMixBackgroundLayout('dark-only');
			document.body.className = 'dark-only';
			localStorage.setItem('mix_background_layout', 'dark-only');
			setMoonlight(true);
		}
	};

	const [tooltipOpen, setTooltipOpen] = useState(false);
	const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

	return (
		<li>
			<div className={`mode ${moonlight ? 'active' : ''}`} onClick={() => MoonlightToggle(moonlight)} id="MoonlightTooltip">
				<SvgIcon iconId={'moon'} />
			</div>
			<Tooltip
				placement="left"
				isOpen={tooltipOpen}
				target="MoonlightTooltip"
				toggle={toggleTooltip}
			>
				<strong>{moonlight ? t('Enable Light Mode') : t('Enable Dark Mode')}</strong>
			</Tooltip>
		</li>
	);
};

export default MoonLight;
